module.exports = __webpack_public_path__ + "img/Android_man_avatar_idle_.9c28eb3f.png";